import { useLocation } from 'react-router-dom';
import BackgroundEffect from '../site/BackgroundEffect';
import Header from './Header';

const BaseLayout = ({ children }) => {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <div className="min-h-screen relative">
      <BackgroundEffect />
      <div className="relative z-10">
        {!isHome && <Header />}
        {children}
      </div>
    </div>
  );
};

export default BaseLayout;
